
import React from 'react';
import RichTextEditor from './RichTextEditor';
import { saveBusinessSetting } from '@/utils/businessService';

interface FAQEditorProps {
  initialContent: string;
  onSaved?: () => void;
}

const FAQEditor: React.FC<FAQEditorProps> = ({ initialContent, onSaved }) => {
  const handleSave = async (content: string) => {
    await saveBusinessSetting('faq', content);
  };

  return (
    <RichTextEditor
      title="Frequently Asked Questions"
      initialContent={initialContent}
      onSave={handleSave}
      onSaved={onSaved}
    />
  );
};

export default FAQEditor;
